import { FC, useEffect, useState, useRef } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import EditorLink from 'lowcode/components/EditorLink';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper';
import { getShopifyProductList } from 'lowcode/apis/getShopifyProductList';
import { FormatMoneyLocal } from 'eco-design-micro/price/FormatMoneyLocal';
import styled from './index.module.scss';
import { products, IProductItem } from './config';
import DutyFreeModal from './DutyFreeModal2';
import { useLang } from '@/app/utils/useLang';
import getLocal from '@/app/utils/getLocal';
import gtm from '@/utils/gtm';
import EcoLink from 'eco-design/base/eco-link';

const ProductList: FC = () => {
    const { locale } = getLocal();
    const { t } = useLang('theProduct.productlist');
    const [list, setList] = useState(products[locale] || products.eu);
    const [chooseItem, setChooseItem] = useState<null | IProductItem>(null);
    const swiperRef = useRef<any>(null);

    const variantIds = list?.map((item) => item.variantId);

    const initProductList = () => {
        getShopifyProductList(locale, variantIds).then((res) => {
            // 混入img productTitle price等参数
            const newList = list.map((item) => {
                const target = res.find((resItem: any) => resItem.variantId === item.variantId);
                return {
                    ...item,
                    img: target?.variantImg,
                    price: target?.price,
                    productTitle: target?.skuTitle,
                };
            });
            setList(newList);
        });
    };
    const handleClick = (item: IProductItem) => {
        gtm.push({
            event: 'uaEvent',
            event_name: 'checkout',
            button_name: `${t('productlist_btn')}_${item.productTitle}`,
        });
        if (locale === 'de') {
            setChooseItem(item);
        } else {
            window.open(item.link, '_blank');
        }
    };

    const handlePrev = () => {
        swiperRef.current?.slidePrev();
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            list_name: t('productlist_title'),
            button_name: 'Left switch',
        });
    };

    const handleNext = () => {
        swiperRef.current?.slideNext();
        gtm.push({
            event: 'uaEvent',
            event_name: 'product_preview_page',
            list_name: t('productlist_title'),
            button_name: 'Right switch',
        });
    };

    useEffect(() => {
        initProductList();
    }, []);

    return (
        <div className={styled.ProductList} id="Products">
            <p className="title">{t('productlist_title')}</p>
            <div className="product_central">
                <Swiper
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                    className="product_box"
                    modules={[Navigation]}
                    spaceBetween={30}
                    navigation={{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    }}
                    // centeredSlides={true}
                    slidesPerView={'auto'}
                    initialSlide={0}
                    scrollbar={{
                        hide: false,
                        draggable: true,
                        dragSize: 32,
                        snapOnRelease: true,
                    }}
                >
                    {list.map((item, index) => (
                        <SwiperSlide className="product_item" key={item.variantId + index}>
                            <span className="tips">{item.tips}</span>
                            <div className="product-top">
                                <EcoLink className="img-link" href={item.detailsLink}>
                                    <EditorImg
                                        className="img"
                                        pc={item.img || 'https://websiteoss.ecoflow.com/upload/image/1724739924894/sl_d3s.png'}
                                        alt={item.productTitle}
                                    />
                                </EcoLink>
                                <p className="save">{item.save}</p>
                                <EcoLink href={item.detailsLink}>
                                    <p className="name">{item.productTitle}</p>
                                </EcoLink>
                                <p className="desc">{item.desc}</p>
                            </div>
                            <div className="product-bottom">
                                {/* <div className="save">
                                    <span>{item.save}</span>
                                </div> */}
                                <div className="price-line">
                                    {t('deposit')}
                                    <span className="price">{FormatMoneyLocal(((item.price || 0) / 10).toFixed(2), locale)}</span>
                                    {/* <span className="price-desc">{item.priceDesc}</span> */}
                                </div>
                                <div className="message">{item.message}</div>
                                <EditorLink className="btn" onClick={() => handleClick(item)}>
                                    {t('productlist_btn')}
                                </EditorLink>
                            </div>
                        </SwiperSlide>
                    ))}
                    <div className="swiper-button-prev" onClick={handlePrev} />
                    <div className="swiper-button-next" onClick={handleNext} />
                </Swiper>
            </div>
            <DutyFreeModal item={chooseItem} show={chooseItem !== null} close={() => setChooseItem(null)} />
        </div>
    );
};

export default ProductList;
